import React from 'react';
import { LoginContextType } from '../types/types';

export const LoginContext = React.createContext<Partial<LoginContextType>>({});
